"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHMenuOption = void 0;
const KHEventHandler_1 = require("../KHEventHandler");
class KHMenuOption extends KHEventHandler_1.KHEventHandler {
    constructor(text, description, selectable = false, callback = null, back_callback = null, extras = {}) {
        super([
            KHMenuOption.UPDATE_DESCRIPTION,
            KHMenuOption.UPDATE_LOCKED,
            KHMenuOption.UPDATE_SELECTABLE,
            KHMenuOption.UPDATE_SELECTED,
            KHMenuOption.UPDATE_SELECTION_OPTION,
            KHMenuOption.UPDATE_TEXT,
        ]);
        this.locked = false;
        this.text = text !== null && text !== void 0 ? text : "";
        this.description = description !== null && description !== void 0 ? description : "";
        this.selectable = selectable;
        this.callback = callback;
        this.back_callback = back_callback;
        this.idx = -1;
        this.extras = extras;
    }
    static JustText(text, extras = null) {
        return new KHMenuOption(text, null, null, null, null, extras);
    }
    static Spacer() {
        return KHMenuOption.JustText("");
    }
    getSelectable() {
        return this.selectable;
    }
    setSelectable(selectable) {
        this.selectable = selectable;
        this.emitEvent(KHMenuOption.UPDATE_SELECTABLE, { selectable: selectable });
    }
    getSelected() {
        return this.selected;
    }
    setSelected(selected) {
        this.selected = selected;
        this.emitEvent(KHMenuOption.UPDATE_SELECTED, { selected: selected });
    }
    getText() {
        return this.text;
    }
    setText(text) {
        this.text = text;
        this.emitEvent(KHMenuOption.UPDATE_TEXT, { text: text });
    }
    getDescription() {
        return this.description;
    }
    setDescription(text) {
        this.description = text;
        this.emitEvent(KHMenuOption.UPDATE_DESCRIPTION, { text: text });
    }
    getLocked() {
        return this.locked;
    }
    setLocked(locked) {
        this.locked = locked;
        this.emitEvent(KHMenuOption.UPDATE_LOCKED, { locked: locked });
    }
}
exports.KHMenuOption = KHMenuOption;
KHMenuOption.UPDATE_LOCKED = "ul";
KHMenuOption.UPDATE_DESCRIPTION = "ud";
KHMenuOption.UPDATE_SELECTABLE = "us";
KHMenuOption.UPDATE_SELECTED = "usel";
KHMenuOption.UPDATE_TEXT = "ut";
KHMenuOption.UPDATE_SELECTION_OPTION = "uso";
